(() => {
  if (window.dibaoCatalogV59Loaded) return;
  window.dibaoCatalogV59Loaded = true;

  if (!customElements.get('dibao-collection-directory')) {
    customElements.define('dibao-collection-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.items = [...this.querySelectorAll('[data-directory-item]')];
        this.buttons = [...this.querySelectorAll('[data-directory-filter]')];
        if (!this.items.length || !this.buttons.length) return;
        this.controller = new AbortController();
        this.items.forEach((item) => {
          const name = `${item.dataset.collectionName} ${item.dataset.collectionHandle}`.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
          item.dataset.directoryGroup = /burgundy|勃艮第|drc|romanee|羅曼尼|echezeaux|依瑟索|拉塔希|la-tache|拉榭|richebourg|里奇堡|montrachet|蒙哈榭|rousseau|saint-vivant|聖維旺/.test(name) ? 'burgundy'
            : /bordeaux|波爾多|lafite|拉菲|latour|拉圖|mouton|木桐|武當|margaux|瑪歌|haut-brion|侯伯王|petrus|petrvs|柏圖斯|帕圖斯|柏翠|le-pin|lepin|裡鵬|angelus|金鐘|ausone|歐頌|歐松|pavie|柏菲/.test(name) ? 'bordeaux'
              : /opus|一號|screaming|嘯鷹|penfolds|奔富/.test(name) ? 'world' : 'other';
        });
        this.buttons.forEach((button) => {
          const key = button.dataset.directoryFilter;
          const count = this.items.filter((item) => key === 'all' || item.dataset.directoryGroup === key).length;
          button.hidden = count === 0;
          button.querySelector('[data-filter-count]').textContent = String(count);
          button.addEventListener('click', () => this.filter(key), { signal: this.controller.signal });
        });
        this.querySelector('[data-directory-tools]').hidden = false;
        this.filter('all');
      }

      filter(key) {
        let visible = 0;
        this.items.forEach((item) => {
          item.hidden = key !== 'all' && item.dataset.directoryGroup !== key;
          if (!item.hidden) visible += 1;
        });
        this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.directoryFilter === key)));
        const english = this.dataset.locale === 'en';
        this.querySelector('[data-directory-status]').textContent = english
          ? `${visible} of ${this.items.length} collections on this page`
          : `本頁顯示 ${visible} / ${this.items.length} 個系列`;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  const enhanceTables = (root = document) => {
    root.querySelectorAll('[data-catalog-tables]').forEach((content) => {
      content.querySelectorAll('table').forEach((table) => {
        let wrapper = table.closest('.dibao-table-scroll');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'dibao-table-scroll';
          table.before(wrapper);
          wrapper.append(table);
        }
        if (wrapper.dataset.catalogTableReady) return;
        wrapper.dataset.catalogTableReady = 'true';
        wrapper.classList.add('dibao-catalog-table-scroll');
        const english = content.dataset.tableLocale === 'en';
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('tabindex', '0');
        wrapper.setAttribute('aria-label', english ? 'Table: scroll horizontally to view all columns' : '表格：可左右捲動查看全部欄位');
        const hint = document.createElement('p');
        hint.className = 'dibao-catalog-table-hint';
        hint.textContent = english ? 'Scroll horizontally to view all columns →' : '左右滑動查看完整表格 →';
        wrapper.before(hint);
        const sync = () => {
          hint.hidden = wrapper.scrollWidth <= wrapper.clientWidth + 1;
        };
        if ('ResizeObserver' in window) new ResizeObserver(sync).observe(wrapper);
        sync();
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceTables(), { once: true });
  else enhanceTables();
  document.addEventListener('shopify:section:load', (event) => enhanceTables(event.target));
})();
